// Awareness (cursors remotos) via Yjs awareness protocol. Hocuspocus expõe
// awareness em `.awareness` mas o tipo vem de `y-protocols` (não re-exportado).
// Tipamos minimamente para evitar dependência transitiva no front.

export interface AwarenessLike {
  clientID: number;
  setLocalState(state: Record<string, unknown> | null): void;
  getStates(): Map<number, unknown>;
}
type Awareness = AwarenessLike;

export interface RemoteCursor {
  clientId: number;
  userId: string | null;
  name: string | null;
  color: string;
  worldX: number;
  worldY: number;
  ts: number;
  selectedNodeId: string | null;
}

const COLORS = ['#00f5ff', '#ff00e5', '#fff200', '#39ff14', '#ff9500', '#9d4edd'];

export function pickColor(userId: string | null): string {
  if (!userId) return COLORS[0]!;
  let hash = 0;
  for (let i = 0; i < userId.length; i++) hash = (hash * 31 + userId.charCodeAt(i)) | 0;
  return COLORS[Math.abs(hash) % COLORS.length]!;
}

export function publishCursor(
  awareness: Awareness,
  payload: { userId: string | null; name: string | null; worldX: number; worldY: number; selectedNodeId?: string | null },
): void {
  awareness.setLocalState({
    user: { id: payload.userId, name: payload.name, color: pickColor(payload.userId) },
    cursor: { x: payload.worldX, y: payload.worldY, ts: Date.now() },
    selection: { nodeId: payload.selectedNodeId ?? null },
  });
}

export function readRemoteCursors(awareness: Awareness, selfClientId: number): RemoteCursor[] {
  const out: RemoteCursor[] = [];
  awareness.getStates().forEach((state, clientId) => {
    if (clientId === selfClientId) return;
    const s = state as {
      cursor?: { x: number; y: number; ts: number };
      user?: { id: string | null; name: string | null; color: string };
      selection?: { nodeId: string | null };
    };
    if (!s.cursor || !s.user) return;
    out.push({
      clientId,
      userId: s.user.id,
      name: s.user.name,
      color: s.user.color,
      worldX: s.cursor.x,
      worldY: s.cursor.y,
      ts: s.cursor.ts,
      selectedNodeId: s.selection?.nodeId ?? null,
    });
  });
  return out;
}
